import React from 'react';
import './PageNotFound.css';

const PageNotFound = () => {
  return (
    <div className="pnf" data-testid="pnf-container">
      <h1 className="pnf-title">404</h1>
      <h2 className="pnf-heading">Oops ! Page Not Found</h2>
    </div>
  );
};

export default PageNotFound;
